import { Box, ModBox, Text, useWindowDimensions } from '@jfs/ui-new'
import { Accordion } from '../../comps/Accordion'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import ContactUs from './ContactUs'

export const Faqs = ({ hide = false }) => {
  if (hide) {
    return null
  }

  const resPadding = usePadding()
  const { headerSize } = useFontSize()
  const viewPortWidth = useWindowDimensions()

  const isMobile = viewPortWidth < 600
  return (
    <Box
      bg={'WHITE'}
      marginTop={isMobile ? -24 : -100}
      pv={isMobile ? 32 : 120}
      borderTopLeftRadius={isMobile ? 24 : 100}
      borderTopRightRadius={isMobile ? 24 : 100}>
      <Box ph={resPadding}>
        <Text
          title={`Frequently Asked Questions`}
          fontFamily={'jiotype-black'}
          fontSize={headerSize}
          color={'BLACK_21'}
          textAlign={isMobile ? 'left' : 'center'}
          lineHeight={isMobile ? 40 : undefined}
        />
        <Box pt={isMobile ? 20 : 80}>
          <Accordion type={'Partner program'} size={4} screenType={'comp'} />
        </Box>
      </Box>
      <ModBox marginTop={isMobile ? 48 : 120}>
        <ContactUs type={'footer'} />
      </ModBox>
    </Box>
  )
}
